(function () {
    const Loader = function (element) {
        this.element = element;
        this.width = 0;
        this.height = 0;
    };
    let fn = Loader.prototype;
    fn.show = function (src, width, height) {
        const o = this;
        o.width = width;
        o.height = height;
        o.element.classList.add('imageZoomLoader__root--visible');
        const container = o.element.querySelector('[data-browse-images-loader-image]');
        container.innerHTML = '';
        if (!!src && !!width && !!height) {
            const img = document.createElement('IMG');
            container.appendChild(img);
            img.src = src;
            o.setSize.call(o);
        }
    };
    fn.hide = function () {
        this.element.classList.remove('imageZoomLoader__root--visible');
    };
    fn.setSize = function () {
        const o = this;
        if (o.width > 0 && o.height > 0) {
            const img = o.element.querySelector('[data-browse-images-loader-image] IMG');
            const e = o.element;
            const boxRatio = e.offsetWidth / e.offsetHeight;
            const imgRatio = o.width / o.height;
            if (imgRatio > boxRatio) {
                img.style.width = Math.min(o.width, e.offsetWidth) + 'px';
                img.style.height = Math.floor((Math.min(o.width, e.offsetWidth) / imgRatio)) + 'px';
            } else {
                img.style.height = Math.min(o.height, e.offsetHeight) + 'px';
                img.style.width = Math.floor((Math.min(o.height, e.offsetHeight) * imgRatio)) + 'px';
            }
        }
    };

    window.addEventListener('load', function () {
        document.querySelectorAll('[data-browse-images-loader]').forEach(function (element) {
            const loader = new Loader(element);
            element.addEventListener('show', function (e) {
                loader.show(e.detail.src, parseInt(e.detail.width), parseInt(e.detail.height));
            });
            element.addEventListener('hide', function (e) {
                loader.hide();
            });
            let timeout = 0;
            window.addEventListener('resize', function () {
                clearTimeout(timeout);
                timeout = setTimeout(loader.setSize, 100);
            });
        })
    })
})();
